import { atom } from 'jotai';

export const supportOpenAtom = atom<boolean>(false);
